import { FC, useState, useRef, useEffect, ReactNode } from 'react';
import classNames from 'classnames';
import { Icon } from 'common-components';
import styles from './rightSidePanel.module.scss';

const RightSidePanel: FC<{
    children: ReactNode;
    onClose: Function;
    isOpen: boolean;
    useBackgrounds?: boolean;
    initialRight?: string;
    finalRight?: string;
    top?: string;
    lightTheme?: boolean;
    includeRefsElement?: any[];
}> = ({
    children,
    onClose,
    isOpen,
    useBackgrounds = true,
    initialRight = '-38rem',
    finalRight = '0px',
    top = '0px',
    lightTheme = false,
    includeRefsElement = []
}: {
    children: ReactNode;
    onClose: Function;
    isOpen: boolean;
    useBackgrounds?: boolean;
    initialRight?: string;
    finalRight?: string;
    top?: string;
    lightTheme?: boolean;
    includeRefsElement?: any[];
}) => {
    const ref = useRef() as React.MutableRefObject<HTMLInputElement>;
    const [right, setRight] = useState<String>(initialRight);
    const [show, setShow] = useState<boolean>(false);
    const [fadeOutAnimation, setFadeOutAnimation] = useState<boolean>(false);

    const checkIncludedElementsRef = (target: any) => {
        return includeRefsElement.some((elemnt: any) => {
            return elemnt.current && elemnt.current.contains(target);
        });
    };

    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {
            const isInformationDialogOpen = !!document.querySelector('.informationDialog-module_background-wrapper');

            if (
                isOpen &&
                ref.current &&
                !ref.current.contains(e.target) &&
                !checkIncludedElementsRef(e.target) &&
                !e.target.classList.contains('MuiBackdrop-root') &&
                !e.target.closest('.MuiPopover-root') &&
                !e.target.closest('.MuiMenu-root') &&
                !e.target.closest('.MuiSelect-root') &&
                !isInformationDialogOpen
            ) {
                onClose();
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            setRight(finalRight);
            setShow(true);
        } else {
            setFadeOutAnimation(true);
            setRight(initialRight);
            window.setTimeout(() => {
                setShow(false);
                setFadeOutAnimation(false);
            }, 500);
        }
    }, [children, isOpen]);

    return isOpen || show ? (
        <div
            className={classNames(styles['right-side-panel'], fadeOutAnimation ? styles['fade-out-animation'] : '')}
            style={{ '--top': top } as any}
        >
            <div
                ref={ref}
                className={styles.content}
                style={
                    {
                        '--right': right,
                        width: lightTheme ? '33.75' : '38rem',
                        backgroundColor: lightTheme ? 'white' : '#141626'
                    } as any
                }
            >
                {children}
                {lightTheme && <Icon name="grayClose" className={styles.close} onClick={() => onClose()} />}
                {useBackgrounds && !lightTheme && (
                    <div
                        className={styles['top-background']}
                        style={{
                            backgroundImage: lightTheme
                                ? undefined
                                : `url(${process.env.PUBLIC_URL}/images/rightExpandTop.svg)`
                        }}
                    />
                )}
                {useBackgrounds && !lightTheme && (
                    <div
                        className={styles['bottom-background']}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL}/images/rightExpandBottom.svg)`
                        }}
                    />
                )}
            </div>
        </div>
    ) : null;
};

export default RightSidePanel;
